import React from 'react';
import P1 from '../../assets/images/p1.png';
import P2 from '../../assets/images/p2.png';
import P3 from '../../assets/images/p3.png';

const TeamMember = ({ name, position, description }) => {
    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden group">
            <div className="relative">
                <img src={P2} alt={name} className="w-full h-auto" />
                <div className="absolute inset-0 bg-purple-700 bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="flex space-x-4">
                        <a href="#" className="text-white hover:text-green-400">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-linkedin"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                        </a>
                        <a href="#" className="text-white hover:text-green-400">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                        </a>
                    </div>
                </div>
            </div>
            <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-1">{name}</h3>
                <p className="text-purple-700 mb-4">{position}</p>
                <p className="text-gray-600">{description}</p>
            </div>
        </div>
    );
};

const Team = () => {
    const teamMembers = [
        {
            name: "John Doe",
            position: "CEO & Founder",
            description: "Tech enthusiast with 15+ years of experience in IT solution development and business digitization."
        },
        {
            name: "Jane Smith",
            position: "CTO",
            description: "Software architecture expert specializing in enterprise-level applications and digital transformation."
        },
        {
            name: "Alex Johnson",
            position: "Lead Developer",
            description: "Full-stack developer with expertise in creating scalable and user-friendly applications."
        },
        {
            name: "Sara Patel",
            position: "UX/UI Designer",
            description: "Creative designer focused on creating intuitive and engaging user experiences for web and mobile."
        }
    ];

    return (
        <section id="team" className="py-16 md:py-24">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Team</h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Meet the enthusiastic professionals driving innovation at Purpuligo Technologies.
                    </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {teamMembers.map((member, index) => (
                        <TeamMember
                            key={index}
                            name={member.name}
                            position={member.position}
                            description={member.description}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;